(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complete-the-fit-products"] && !Shopify.designMode) return;
  try {
    class CompleteFitUpsell extends HTMLElement {
    constructor() {
      super();
      this.onQuickAdd = this.onQuickAdd.bind(this);
    }

    async onQuickAdd(event) {
      const button = event.target.closest('[data-complete-fit-add]');
      if (!button) return;

      if (button.dataset.completeFitViewCart === 'true') {
        event.preventDefault();

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }

        window.location.href = (typeof Theme !== 'undefined' && Theme.routes?.cart_url) || '/cart';
        return;
      }

      const variantId = button.dataset.variantId;
      if (!variantId || button.getAttribute('aria-busy') === 'true') return;

      const label = button.querySelector('[data-complete-fit-add-label]');
      const originalLabel = label?.textContent;
      const viewCartLabel = button.dataset.viewCartLabel || 'View cart';
      const status = this.querySelector('[data-complete-fit-status]');
      let showViewCart = false;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = button.dataset.loadingLabel || 'Adding';
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      try {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((component) => component.dataset.sectionId)
          .filter(Boolean);
        const body = {
          id: Number(variantId),
          quantity: 1,
        };

        if (sectionIds.length > 0) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(body),
        });
        const payload = await response.json();

        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add item.');
        }

        const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
        });
        const cart = await cartResponse.json();

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'complete-fit-upsell',
              data: {
                source: 'complete-fit-upsell',
                itemCount: cart.item_count,
                variantId,
                sections: payload.sections || {},
              },
            },
          })
        );

        if (status) {
          status.textContent = this.dataset.successMessage || 'Added to cart.';
          status.hidden = false;
        }

        button.dataset.completeFitViewCart = 'true';
        button.classList.add('complete-fit-card__add--view-cart');
        if (label) label.textContent = viewCartLabel;
        button.setAttribute('aria-label', viewCartLabel);
        showViewCart = true;
      } catch (error) {
        if (status) {
          status.textContent = error.message;
          status.hidden = false;
        }
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (!showViewCart && label && originalLabel) label.textContent = originalLabel;
      }
    }
  }

  if (!customElements.get('complete-fit-upsell')) {
    customElements.define('complete-fit-upsell', CompleteFitUpsell);
  }

  if (!window.completeFitUpsellClickBound) {
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const upsell = event.target.closest('complete-fit-upsell');
      if (!upsell || typeof upsell.onQuickAdd !== 'function') return;

      upsell.onQuickAdd(event);
    });

    window.completeFitUpsellClickBound = true;
  }
  } catch(e) { console.error(e); }
})();

})();
